import { render, staticRenderFns } from "./CardImgCenter.vue?vue&type=template&id=ee429b78&scoped=true&"
var script = {}
import style0 from "./CardImgCenter.vue?vue&type=style&index=0&id=ee429b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee429b78",
  null
  
)

export default component.exports